export default function geolocationModalSelect() {
  // Hidden dropdown selector for 'GeoLocation Modal'.
  let dropdownSelector = jQuery('#modal-location');
  // Hidden dropdown selector for 'State Filter'.
  let stateSelector = jQuery('#filter-state-assn option:selected');
  
  // console.log(dropdownSelector);

  if (dropdownSelector) {
    // console.log('Dropdown exists');

    dropdownSelector.on('change', function() { 
      var newValue = jQuery(this).val();
      var newText = jQuery(this).text();

      // Update the hidden 'State Selector' dropdown, to trigger filtering.
      stateSelector.val(newValue).text(newText).change();
      // Update the visible text.
      jQuery('#filter-state-assn-selectized').val(newText);

      
      // Close Modal altogether, once we have the data AND it has been populated.
      let modalTrigger = document.getElementsByClassName("modal-item open-modal");
      let triggerArray = Array.from(modalTrigger).entries();
      for (let [index, modalTriggerItem] of triggerArray) {
        modalTriggerItem.classList.toggle("open-modal");
        // console.log(modalTrigger);
      }
   });
  }
}
